"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ABI = __importStar(require("../../abis"));
const contract_base_1 = __importDefault(require("../contract-base"));
class UniswapV2Router extends contract_base_1.default {
    constructor(connectionConfig, contractAddress) {
        super(connectionConfig, contractAddress, ABI.UniswapV2RouterABI);
    }
    getAmountsOut(amountIn, path) {
        return __awaiter(this, void 0, void 0, function* () {
            const amounts = yield this.contract.methods.getAmountsOut(amountIn, path).call();
            return amounts[path.length - 1] || 0;
        });
    }
    getAmountsIn(amountOut, path) {
        return __awaiter(this, void 0, void 0, function* () {
            const amounts = yield this.contract.methods.getAmountsIn(amountOut, path).call();
            return amounts[0] || 0;
        });
    }
}
exports.default = UniswapV2Router;
//# sourceMappingURL=uniswap-v2-router-contract-interface.js.map